<template>
  <div>
    <div>
      <!-- Breadcrumbs with home icon and links to travel services page -->
      <ol
        class="breadcrumb container d-none d-md-flex py-0"
        style="
          border-radius: 0px;
          background-color: white;
          height: 60px;
          margin: 0 auto;
        "
      >
        <li>
          <a href="/" class="has-icon icon-l text-dark">
            <i class="material-icons"></i>
            Home
          </a>
        </li>
        <li>
          <a href="/travel-services" class="text-dark"
            >Travel Services</a
          >
        </li>
        <li class="active">{{mainpage.title}}</li>
      </ol>
    </div>
    <!-- Load page top background image with title and summary-->

    <div class="app-hero-img">
<!--      <b-img :src="getBkgImageUrl()" alt="Trailfinders Visa Service"></b-img>-->
      <b-img :src="mainpage.web_main_image" :alt="mainpage.title"></b-img>
      <div class="d-flex justify-content-center" style=" z-index:5">
          <div class="caption-centered position-absolute top-40 bg-dark bg-opacity-50 p-3 justify-content-center"
               style="border-radius:20px; max-width:550px; z-index:5;">
            <div class="flex-column text-center text-light">
            <h1 class="text-light mb-2">{{mainpage.title}}</h1>
            <h3 class="text-light fs-6">
              <span>{{mainpage.web_charge_details}}</span>
            </h3>
          </div>
        </div>
      </div>
    </div>
    <!-- Message to click on flags for relevant country visa -->

    <div class="container p-0">

      <div class="mt-5 mb-5 mx-4">
        <h5 class="text-center" v-html="mainpage.web_visa_policy"></h5>
      </div>


<!--    <div class="container p-0">-->
      <b-row class="justify-content-center">
        <!-- Load the flags with headers -->
        <b-card
          v-for="(d, index) in countries"
          :key="index"
          :img-src="getFlagUrl(d.country)"
          img-alt="Image"
          img-top
          tag="article" role="button"
          style="flex-basis:10rem"
          class="mb-4 mx-4 w-10 h-13rem p-0 d-block"
          @click="countrySelected(d)"
        >
          <b-card-title
           class="text-center fs-6"
            text-align="center"
            ><strong>{{ d.webpage_title}}</strong></b-card-title
          >
        </b-card>
      </b-row>
<!--      @click="countryClicked(index)"-->
      <!-- Bottom messages -->
      <b-row class="mt-4 mb-4 justify-content-center">
        <div class="col-xs-12 col-sm-12 mb-12" style="width: 50em">
          <div class="panel panel-light">
            <div class="panel-body">
              <div v-html="mainpage.web_page_copy"></div>
              <br />

              <div class="col-xs-12 col-sm-5 mb-6"
                   style="float: left; margin-bottom: 1.25rem; text-align: center; margin-left: 2.5em">
                <p><b>Trailfinders Visa Service UK</b></p>
                  <div v-html="mainpage.uk_address"></div>
              </div>

              <div class="col-xs-12 col-sm-5 mb-6"
                   style="float: left; text-align: center; margin-left: 2.5em">
                <p><b>Trailfinders Visa Service Ireland</b></p>
                <div v-html="mainpage.ie_address"></div>
              </div>
              <div style="clear:both;"></div>


              <section class="row justify-content-center">
                <div class="col-12 col-sm-8">
                  <div class="py-5 text-center">
                    <img src="https://cdn.trailfinders.com/ppd5eabkgc_trustpilot-logo.png" alt="Trustpilot Cruise" title="Trustpilot Cruise" class="w-100 lazy">
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getMainPage, getVisaCountries } from "@/services/api.js";

// `https://www.trailfinders.${this.getUrlDomain(this.getRegion())}/img/visas/passport-banner.jpg`
// `https://cdn.trailfinders.com/images/261776/ire%20passport_eh_retouch.jpg?width=1500`,

export default {
  data() {
    return {
      meta: {
        loaded: true,
      },
      mainpage: {},
      passportSectionComplete: false,
      mobile: window.innerWidth <= 700,
      countries: [],
      // images: [
      //   `https://cdn.trailfinders.com/images/3598676/convertkit-htqzns-rx7w-unsplash.jpg?width=1500`,
      //   `https://cdn.trailfinders.com/images/261776/ire%20passport_eh_retouch.jpg?width=1500`,
      // ],
    };
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 700;
    });
  },
  mounted() {
    this.meta.loaded = true;
    this.getMainPage();

  },

  methods: {
    getFlagUrl(title) {
      let country = title.split(" ")[0];
      country = country === "Australian" ? "Australia" : country;
      country =
        country === "Easter" ? "Easter_Island_Online_Registration" : country;
      country = country === "New" ? "New_Zealand_ETA" : country;
      country = country === "USA" ? "USA_ESTA" : country;
      country = country === "Sri" ? "Sri_Lanka" : country;
      country = country === "Gap" ? "Gap_Year_and_Student_Travel" : country;
      country = country === "Indian" ? "India" : country;
      return `https://cdn.trailfinders.com/static/codesource/img/visas/flags/${country}.png`;
    },
    // async getPageData() {
    //   const referer = window.siteVar.referer;
    //   const countriesData = await getPageData(referer);
    //   this.countries = countriesData;
    //   this.countries = this.countries.filter((item) => {
    //     if (referer === item.visa_code_link.split("/")[3].substring(0, 2)) {
    //       return item;
    //     }
    //   });
    //   this.meta.loaded = true;
    // },
    async getMainPage() {
      const referer = window.siteVar.referer;
      const mainpageData = await getMainPage(referer);
      this.mainpage = mainpageData[0];
      const countriesData = await getVisaCountries(referer);
      countriesData.sort((a,b) => (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0))
      this.countries = countriesData;

      this.meta.loaded = true;
    },
    countrySelected(_obj) {
      if(_obj) {
        if(_obj.country) {
          if(_obj.country.toLowerCase()==='cuba') {
            const cubanVisaUrl = `https://www.trailfinders.${this.getUrlDomain(this.getRegion())}/visas/cuba#/`
            // const cubanVisaUrl = `https://www.trailfinders.${this.getUrlDomain(this.getRegion())}/visas/cuba#/`
           // const cubanVisaUrl = `https://www.trailfinders.${this.getUrlDomain(this.getRegion())}/visas#/visas/country/${this.getRegion()}/cuba_tourist_card_service`
           // const cubanVisaUrl = `https://www.trailfinders.${this.getUrlDomain(this.getRegion())}/visas#/visas/country/${this.getRegion()}/${_obj.webpage_title_concat}`
            window.location.href = cubanVisaUrl;
          } else {

            //path: '/visas/country/:site/:webpagetitle',
            this.$router.push({
              name: "visacountry",
              params: {
                site: _obj.site,
                webpagetitle: _obj.webpage_title_concat
              },
            });
          }
        }
      }
    },
    getRegion() {
      let region = "UK";
      if (window.siteVar.referer) {
        region = window.siteVar.referer;
      }
      return region;
    },
    getUrlDomain(region) {
      if(region){
        return region === 'IE' ? "ie" : "com";
      }else{
        return 'com'
      }
    }
  },
};
</script>